import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Carousel from "react-slick";
import ReactApexChart from 'react-apexcharts'

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import { API_BASE_URL } from "views/api";

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";


// Sections for this page


const useStyles = makeStyles(styles);
export const series = (data) => {
  return [{
    data: data
  }];
};

const bar_colors = ['#173F5F', '#20639B', '#3CAEA3', '#F6D55C', '#ED553B']

export const options = (title, categories) => {
  return {
    chart: {
      type: 'bar',
      height: 380,
      fontFamily: 'nepali-font'
    },
    plotOptions: {
      bar: {
        barHeight: '100%',
        distributed: true,
        horizontal: true,
        dataLabels: {
          position: 'bottom'
        },
      }
    },
    colors: bar_colors,
    dataLabels: {
      enabled: true,
      textAnchor: 'start',
      style: {
        colors: ['#fff', '#fff', '#000', '#000', '#000']
      },
      formatter: function (val, opt) {
        // return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
        return ''
      },
      offsetX: 0,
      dropShadow: {
        enabled: false
      }
    },
    stroke: {
      width: 1,
      colors: ['#fff', '#fff', '#fff', '#fff', '#fff']
    },
    xaxis: {
      categories: categories,
    },
    yaxis: {
      labels: {
        show: false
      }
    },
    title: {
      // text: title,
      text: '',
      align: 'center',
      floating: true,
      style: {
        fontSize: '18px',
      }
    },
    // subtitle: {
    //     text: 'Category Names as DataLabels inside bars',
    //     align: 'center',
    // },
    legend: {
      show: false,
    },
    tooltip: {
      theme: 'dark',
      x: {
        show: false
      },
      y: {
        title: {
          formatter: function () {
            return ''
          }
        }
      }
    }
  };
};

export const title_map = {
  bhaktapur_district: {
    name: 'जि स स भक्तपुर',
  },
  changunarayan: {
    name: 'चाँगुनारायण नगरपालिका',
  },
  bhaktapur: {
    name: 'भक्तपुर नगरपालिका',
  },
  madhyapur_thimi: {
    name: 'मध्यपुर थिमि नगरपालिका',
  },
  suryabinayak: {
    name: 'सूर्यविनायक नगरपालिका'
  }
}
const FISCAL_YEAR_STRING = {
  '1': '2075/76',
  '2': '2076/77',
  '3': '2077/78',
  '4': '2078/79',
  '5': '2079/80',
  '6': '2080/81',
  '7': '2081/82',
  '8': '2082/83',
  '9': '2083/84',
  '10': '2084/85'
}

export default function ProductSection() {
  const classes = useStyles();
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 6000,
  };




  const [slideShow, setSlideShow] = React.useState(0);
  let slider_var;

  const [project_insights, setProjectInsight] = React.useState(undefined);
  const [most_recent_fiscal_year, setMostRecentFiscalYear] = React.useState('');
  const getLatestYearProject = (projectData) => {
    const filterData = projectData
    let remIndex = []
    filterData.forEach((item, i) => {
      filterData.forEach((item_another, j) => {
        if ((item.administrative_unit === item_another.administrative_unit) && (i !== j)) {
          if (item.fiscal_year > item_another.fiscal_year) {
            remIndex.push(j)
          } else {
            remIndex.push(i)
          }
        }
      });
    });
    remIndex = [...new Set(remIndex)]
    remIndex.forEach((item) => {
      filterData.splice(item, 1);
    });
    return filterData
  }

  React.useEffect(() => {
    if (project_insights === undefined) {
      fetch(API_BASE_URL + 'homepage/projects/')
        .then(results => results.json())
        .then(data => {
          // setProjectInsight(data.results);
          const project_data = getLatestYearProject(data.results);
          const fiscal_years = project_data.map(project_unit => project_unit.fiscal_year)
          setMostRecentFiscalYear(Math.max.apply(Math, fiscal_years))
          setProjectInsight(project_data);
        });
    }
  });

  // let administrative_units = []
  // if (project_insights && project_insights.length > 0) {
  //   administrative_units = project_insights.map((b,i)=>([title_map[b.administrative_unit].name ,' (आ. व. '+ FISCAL_YEAR_STRING[budget_insights[i].fiscal_year] + ')']))
  // }

  return (
    <div className={classes.section}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ color: "#134c7a", margin: 0 }}>
            <small>आ. व. <span style={{ fontFamily: 'nepali-font', fontSize: '0.9rem' }}>{FISCAL_YEAR_STRING[most_recent_fiscal_year]}</span></small>
            <span><h3 className={classes.title} style={{ marginTop: '0px', color: '#134c7a' }}>योजना तथा परियोजना</h3></span>
            <div style={{ width: '20px', borderBottom: "5px solid #134c7a", margin: 'auto' }}></div>
          </div>

          <GridContainer>
            <GridItem xs={12} sm={12} md={10} style={{ margin: 'auto' }}>
              <Card carousel>
                {project_insights &&

                  <Carousel {...settings} beforeChange={(oldIndex, index) => { setSlideShow(index) }} ref={slider => (slider_var = slider)}>
                    {project_insights && project_insights.map((project_insight, i) => {
                      const records = [
                        { category: 'आर्थिक विकासका योजनाहरु', data: project_insight.economic_development, color: bar_colors[0] },
                        { category: 'पूर्वाधार विकासका योजनाहरु', data: project_insight.infrastructure_development, color: bar_colors[1] },
                        { category: 'सस्थागत विकास तर्फका योजनाहरु', data: project_insight.institutional_development, color: bar_colors[2] },
                        { category: 'सामाजिक विकासका योजनाहरु', data: project_insight.social_development, color: bar_colors[3] },
                        { category: 'अन्य योजनाहरु', data: project_insight.other, color: bar_colors[4] }
                      ]
                      return (

                        <GridContainer>
                          <GridItem>
                            <h4 style={{ fontFamily: 'nepali-font' }}>
                              {title_map[project_insight.administrative_unit].name}
                              {' (आ. व.' + FISCAL_YEAR_STRING[project_insight.fiscal_year] + ')'}
                            </h4>
                          </GridItem>
                          <GridItem xs={12} sm={6} md={6} style={{ margin: 0, padding: 0, float: 'left' }}>

                            <table style={{ width: "80%", margin: '20px' }}>
                              <tr>
                                <th><u>योजना को प्रकार</u></th>
                                <th><u>संख्या</u></th>
                              </tr>
                              {records.map((record, i) => {
                                return (
                                  <tr style={{ height: '50px', backgroundColor: i % 2 === 0 ? '#eee' : '#fff' }}>
                                    <td><div style={{ backgroundColor: record.color, height: '20px', width: '20px', float: 'left', marginLeft: '10px' }} />{record.category}</td>
                                    <td style={{ fontFamily: 'nepali-font' }}>{record.data}</td>
                                  </tr>
                                )
                              })}
                            </table>
                          </GridItem>
                          <GridItem xs={12} sm={6} md={6} style={{ margin: 0, padding: 0, float: 'right' }}>
                            <ReactApexChart options={options(title_map[project_insight.administrative_unit].name, records.map(r => r.category))} series={slideShow === i ? series(records.map(r => r.data)) : series(records.map(r => 0))} type="bar" height={350} />
                          </GridItem>
                        </GridContainer>
                      );
                    }
                    )}
                  </Carousel>
                }
              </Card>
            </GridItem>
            <GridContainer justify="center" style={{ margin: 'auto' }} xs={12} sm={12} md={12}>
              <GridItem xs={12} sm={12} md={12}>
                {project_insights && project_insights.map((project_insight, i) =>
                  <Button onClick={() => slider_var.slickGoTo(i)} color="transparent" style={slideShow === i ? { color: '#134c7a', border: '1px solid #134c7a', borderRadius: '100px', padding: '4px' } : { color: '#134c7a', padding: '5px' }} size="sm">
                    {title_map[project_insight.administrative_unit].name}
                  </Button>
                )}
              </GridItem>
            </GridContainer>
          </GridContainer>
          <Button href="/project" style={{ margin: 'auto', marginTop: '15px' }} color="primary">थप जानकारी</Button>
        </GridItem>
      </GridContainer>
    </div>
  );
}
